// extracted by mini-css-extract-plugin
module.exports = {"section":"Gift_section__3rW-2","section__bg":"Gift_section__bg__35GAt","section__main":"Gift_section__main__15C4U","section__title":"Gift_section__title__1rol6"};